import { shouldUseCustomNavigation } from '@common/utils';

interface Wishlist {
  slug: string;
  id: number;
  title: string;
  currentPrice: number;
  image: string;
  groupId: string;
  productLink: string;
  optionNames: Array<string>;
  optionValues: Array<string>;
  baseProductSlug: string;
}
export const NUM_VARIANTS = 3;

export const processResponse = (wishlist: Record<string, never>): Wishlist => {
  // options: [{name, value:},  {name, value}, {name, value}]
  const productLink = shouldUseCustomNavigation()
    ? `/${wishlist.base_product_slug}/p${wishlist.group_id}`
    : `/product/${wishlist.base_product_slug}`;

  let optionNames = [];
  for (let i = 1; i <= NUM_VARIANTS; i++) {
    optionNames.push(wishlist[`option${i}_name`]);
  }
  optionNames = optionNames.filter((value) => value);

  let optionValues = [];
  for (let i = 1; i <= NUM_VARIANTS; i++) {
    optionValues.push(wishlist[`option${i}_value`]);
  }
  optionValues = optionValues.filter((value) => value);

  return {
    id: wishlist.id,
    slug: wishlist.slug,
    title: wishlist.title,
    image: wishlist.image,
    currentPrice: wishlist.current_price,
    productLink: productLink,
    groupId: wishlist.group_id,
    optionNames,
    optionValues,
    baseProductSlug: wishlist.base_product_slug,
  };
};

export default Wishlist;
